import { AfterViewInit, Component, forwardRef, Input } from '@angular/core';
import { STRINGS } from '../strings';
import { LanguageService } from './core/language.service';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  FormFieldComponent,
  TextBoxComponent,
  ErrorComponent,
} from '@progress/kendo-angular-inputs';
import { LabelComponent } from '@progress/kendo-angular-label';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-input-field',
  template: `
    <kendo-formfield>
      <kendo-label [text]="handleTranslate(fieldConfig)">
        <kendo-textbox
          [formControl]="formControl"
          [class]="'e2e-' + fieldName"
          #inputRef
          [readonly]="fieldConfig?.readOnly || false"
          [required]="fieldConfig?.required || false"
          (blur)="onTextBlur(inputRef)"
        ></kendo-textbox>
      </kendo-label>

      <kendo-formerror>
        {{ getString('formRequired', handleTranslate(fieldConfig)) }}
      </kendo-formerror>
    </kendo-formfield>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFieldComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [
    FormFieldComponent,
    LabelComponent,
    TextBoxComponent,
    FormsModule,
    ReactiveFormsModule,
    ErrorComponent,
  ],
})
export class InputFieldComponent
  implements ControlValueAccessor, AfterViewInit
{
  @Input({ required: true }) handleTranslate!: (
    field: { en?: string; fr?: string } | undefined,
  ) => string;
  @Input({ required: true }) handleTextBlur!: (input: any) => void;
  @Input({ required: true }) fieldConfig?: {
    readOnly: boolean;
    required: boolean;
    en?: string;
    fr?: string;
  };
  @Input({ required: true }) fieldName!: string;

  public formControl: FormControl = new FormControl();

  constructor(private languageService: LanguageService) {}

  public getString(key: keyof typeof STRINGS, ...args: Array<string>) {
    return this.languageService.getString(key, ...args);
  }

  public onTextBlur(input: any) {
    input.control.name = this.fieldName;
    return this.handleTextBlur(input);
  }

  public ngAfterViewInit() {
    if (this.fieldConfig?.readOnly || !!this.formControl.value) {
      this.formControl.markAllAsTouched();
    }
  }

  writeValue(value: any) {
    this.formControl.setValue(value);
  }

  registerOnChange(fn: Function) {
    this.formControl.valueChanges.subscribe((val) => fn(val));
  }

  registerOnTouched(fn: Function) {
    this.formControl.valueChanges.subscribe((val) => fn(val));
  }

  protected readonly environment = environment;
}
